import React from "react";
import { UsersTrackerContent } from "./Card.styled";
import PropTypes from "prop-types";
// import ProgressBar from "./ProgressBar";
// import increaseIcon from "../../assets/icons/increaseIcon.svg";
// import decreaseIcon from "../../assets/icons/decreaseIcon.svg";
// eslint-disable-next-line no-unused-vars
function UsersTracker({ number, rate, progressType }) {
	return (
		<UsersTrackerContent>
           <p className="totalUsers">{number?.toLocaleString() || 0} user(s)</p>
			<div className='mainContent'>
				{/* <p className='numbers'>{number.toLocaleString()}</p> */}
				{/* <div className='rateWrapper'>
					{progressType === "positive" ? (
						<img
							style={{ height: "", width: "" }}
							src={increaseIcon}
							alt='increased rate'
						/>
					) : (
						<img
							style={{ height: "", width: "" }}
							src={decreaseIcon}
							alt='decreased rate'
						/>
					)}

					<p className='rate'>{rate}%</p>
				</div> */}
			</div>

			{/* <div className="progressBar"></div> */}
			{/* <ProgressBar bgcolor='#006770' completedWidth='60' /> */}
		</UsersTrackerContent>
	);
}

UsersTracker.propTypes = {
	// type: PropTypes.string,
	// year: PropTypes.array,
	number: PropTypes.number,
	rate: PropTypes.number,
	progressType: PropTypes.string,
};

export default UsersTracker;
